import { render, staticRenderFns } from "./GoodsReceiptsIndex.vue?vue&type=template&id=2921f1fa&scoped=true&"
import script from "./GoodsReceiptsIndex.vue?vue&type=script&lang=js&"
export * from "./GoodsReceiptsIndex.vue?vue&type=script&lang=js&"
import style0 from "./GoodsReceiptsIndex.vue?vue&type=style&index=0&id=2921f1fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2921f1fa",
  null
  
)

export default component.exports